var React = require('react');

function ProgressDone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10ZM15.602 6.96327L14.1627 5.57457L8.119 11.837L5.59314 9.28534L4.17151 10.6921L8.13725 14.6998L15.602 6.96327Z"}));
}

ProgressDone.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = ProgressDone;

ProgressDone.default = ProgressDone;
